export default __webpack_public_path__ + "img/landscape-placeholder.612b7d41.svg";